import React, { createContext, memo, useReducer, useMemo } from 'react';
import { blocksReducer, defaultBlocksState } from './blocksReducer';
import { usePageEdit } from '../../../ModulePage';
var store = createContext({
    blocks: defaultBlocksState,
    dispatchBlocks: function () {
    }
});
var Provider = store.Provider;
export var useBlocks = function () { return React.useContext(store); };
export var useBlock = function (id) {
    var pageInEditMode = usePageEdit().pageInEditMode;
    var list = useBlocks().blocks.list;
    var block = useMemo(function () { return list[id]; }, [JSON.stringify(list[id]), pageInEditMode]);
    var blockBg = useMemo(function () { return block === null || block === void 0 ? void 0 : block.bg; }, [block]);
    return { block: block, blockBg: blockBg };
};
export var BlocksProvider = memo(function (_a) {
    var children = _a.children;
    var _b = useReducer(blocksReducer, defaultBlocksState), blocks = _b[0], dispatchBlocks = _b[1];
    return (React.createElement(Provider, { value: { blocks: blocks, dispatchBlocks: dispatchBlocks } }, children));
});
